<template>
  <div class="container">
    <div class="main">
      <div class="login-box">
        <div class="title-box-login"><span class="title">管理员登陆</span></div>
        <div class="edit-main">
          <div class="edit-box">
            <span class="label">用户名：</span>
            <input v-model="name" class="input" placeholder="请输入账号" autocomplete="new-password" />
          </div>
          <div class="edit-box">
            <span class="label">密 码：</span>
            <input
              v-model="password"
              class="input"
              type="password"
              placeholder="请输入密码"
              autocomplete="new-password"
            />
          </div>
          <div class="verify-box">
            <div class="edit-box">
              <span class="label">验证码：</span>
              <input v-model="inputCode" class="input" style="width: 0" placeholder="验证码" maxlength="4" />
            </div>
            <img id="code" class="img-verify" arc="code" @click="event().onVerifyImgClicked()" />
          </div>
          <el-button class="login-btn" @click="event().onLogin()">登录</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { encrypt } from "@/filters/filter";
import { login } from "@/api/common";
import { pms2MenuList } from "../filters/filter";
import Utils from "@/jslibs/utils";
import { mapMutations } from "vuex";
// import { LimitsList } from '@/api/auth'

export default {
  data() {
    return {
      code: "",
      inputCode: "",
      name: "",
      password: "",
      rules: [],
      permissionList: [],
      operationList: [
        {
          name: "样例管理",
          operations: ["编辑", "删除", "导出"],
        },
      ],
      menuList: [],
      // mixin operation, index 记得也要改
      noChildMunuList: ["积分设置", "消息推送", "数据统计"],
    };
  },

  created() {},

  mounted() {
    this.handler().refreshCode();
  },
  methods: {
    ...mapMutations(["update_operation_list", "update_permission_list", "updateLoginData"]),
    event() {
      const self = this;
      return {
        onVerifyImgClicked() {
          self.handler().refreshCode();
        },
        onLogin: () => {
          this.network().addlogin();
        },
      };
    },
    network() {
      return {
        /*  getListA() {}, */
        addlogin: async () => {
          if (!this.handler().verifyInput()) return;
          const {
            account,
            token,
            group_id,
            group: { rule },
            name,
            is_sup_admin,
            uuid,
          } = await login({
            account: this.name,
            password: this.password,
          }).catch((error) => {
            throw error;
          });
          Utils.setCookie("X-Access-Token", token, 3);
          Utils.setCookie("X-Access-Name", account, 3);
          Utils.setCookie("X-Access-Group", group_id, 3);
          Utils.setCookie("X-Access-Name", name, 3);
          Utils.setCookie("X-Access-isAdmin", is_sup_admin, 3); // 2为超级管理员 1为普通管理员
          Utils.setCookie("X-Access-uuid", uuid, 3);
          this.handler().buildTree(rule);
        },
      };
    },

    handler() {
      const self = this;
      return {
        refreshCode() {
          // eslint-disable-next-line no-undef
          const res = verifyCode();
          const img = document.getElementById("code");
          img.src = res.dataURL;
          self.code = res.code;
        },
        verifyInput: () => {
          if (!this.name || !this.name.trim()) {
            this.$message({
              message: "请输入账号",
              type: "warning",
            });
            return false;
          }
          if (!this.password || !this.password.trim()) {
            this.$message({
              message: "请输入密码",
              type: "warning",
            });
            return false;
          }
          if (!this.inputCode || !this.inputCode.trim()) {
            this.$message({
              message: "请输入验证码",
              type: "warning",
            });
            return false;
          }
          if (this.code.toLowerCase() !== this.inputCode.toLowerCase()) {
            this.$message({
              message: "验证码错误",
              type: "warning",
            });
            this.handler().refreshCode();
            return false;
          }
          return true;
        },
        buildTree: (tree) => {
          this.permissionList = [];
          this.operationList = [];
          tree = tree.slice(0, 1);
          tree.forEach((one) => {
            const children = [];
            // 只有一级时
            if (this.noChildMunuList.includes(one.menu_name)) {
              if (one.son_rule) {
                const three = one.son_rule;
                this.operationList.push({
                  name: one.menu_name,
                  operations: three,
                });
              }
            }
            if (one.son_rule) {
              one.son_rule.forEach((two) => {
                if (!this.noChildMunuList.includes(one.menu_name)) {
                  children.push({
                    name: two.menu_name,
                    menu_url: two.menu_url,
                  });
                }
                // 把三级权限数据赋给oprationlist
                // 在二级页面根据oprationlist 匹配三级权限
                let three = [];
                if (two.son_rule) {
                  // 如果菜单有二级
                  three = two.son_rule.map((item) => {
                    return item.menu_name;
                  });
                }
                if (!this.noChildMunuList.includes(one.menu_name)) {
                  this.operationList.push({
                    name: two.menu_name,
                    operations: three,
                  });
                }
              });
            }

            const fid0s = this.permissionList.map((item) => item.name);
            if (!fid0s.includes(one.menu_name)) {
              this.permissionList.push({
                name: one.menu_name,
                children,
              });
            }
          });

          const jsonStrPer = JSON.stringify(this.permissionList);
          // // 对权限列表进行加密
          const encryptPer = encrypt(jsonStrPer).toString();
          sessionStorage.setItem("permission", encryptPer);
          // 存储有权限列表和操作列表到store
          this.update_permission_list(encryptPer);
          this.update_operation_list(this.operationList);
          console.log(this.operationList);
          const menuList = pms2MenuList(this.permissionList);

          if (menuList[0].children && menuList[0].children.length) {
            this.$router.push(menuList[0].children[0].route);
          } else {
            this.$router.push(this.menuList[0].route);
          }
        },
      };
    },
  },
};
</script>

<style scoped lang="less">
.container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  .main {
    flex: 1;
    background: url(../assets/images/pic_login_background.jpg) center center no-repeat;
    background-size: cover;
    display: flex;
    justify-content: center;
    align-items: center;
    .login-box {
      position: relative;
      width: 624px;
      height: 365px;
      background: url(../assets/images/login_box_bg.png) center center no-repeat;
      background-size: 100% 100%;
      box-shadow: 0px 2px 16px 0px rgba(0, 0, 0, 0.09);
      .title-box-login {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 110px;
        text-align: center;
        span.title {
          margin: 0 21px;
          font-size: 28px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #fff;
          line-height: 110px;
        }
      }
      .edit-main {
        position: absolute;
        bottom: 0;
        right: 0;
        padding: 18px 17px 5px;
        .edit-box {
          display: flex;
          align-items: center;
          width: 312px;
          height: 45px;
          margin-bottom: 6px;
          padding: 0 12px;
          border-radius: 3px;
          border: 1px solid rgba(32, 53, 128, 0.16);
          .label {
            display: inline-block;
            width: 80px;
            flex-shrink: 0;
            color: #fff;
            font-weight: 900;
          }
          input.input {
            padding: 0 14px;
            height: 70%;
            flex: 1;
            outline: none;
            border: none;
            font-size: 14px;
            background-color: rgba(32, 53, 128, 0);
            border: 2px solid #215a9f;
            border-radius: 5px;
            color: #fff;
          }
        }
        .verify-box {
          position: relative;
          height: 40px;
          width: 336px;
          .edit-box {
            width: 210px;
            float: left;
            display: flex;
            align-items: center;
            height: 40px;
            margin: 0 auto;
            padding: 0 12px;
            border-radius: 3px;
            border: 1px solid rgba(32, 53, 128, 0.16);

            input.input {
              flex: 1;
              outline: none;
              border: none;
              background-color: none !important;
              font-size: 14px;
              background-color: rgba(32, 53, 128, 0);
              border: 2px solid #215a9f;
              border-radius: 5px;
              color: #fff;
            }
          }
          img#code.img-verify {
            float: left;
            width: 90px;
            height: 40px;
            margin-left: 3px;
          }
        }
        .login-btn {
          margin: 27px auto 20px auto;
          width: 336px;
          height: 45px;
          background-color: #0d91ce;
          border: 2px solid #2671b8;
          border-radius: 3px;
          color: #ffffff;
        }
      }
    }
  }
  .foot {
    height: 54px;
    display: flex;
    padding: 27px 0 33px;
    font-size: 14px;
    flex-direction: column;
    align-items: center;
    p:first-child {
      margin: 0;
    }
    p:last-child {
      margin-top: 12px;
    }
  }
}
/deep/input:-internal-autofill-selected {
  background-color: none !important;
}
</style>
